export type Clues = {
  phrases: string[];
  dish?: string;
  cityGuess?: string;
  targetName?: string; // extracted/guessed restaurant name to boost matches
  cuisine?: string; // optional cuisine hint
  // New optional signals
  extraNameHints?: string[]; // from text (@, quoted)
  extraLocHints?: string[];  // from text (areas/cities)
  visionNames?: Array<{ text: string; confidence?: number }>; // from Vision
  visionLocs?: Array<{ text: string; confidence?: number }>;  // from Vision
  // Private ranking signals (threaded from orchestrator)
  ocrBrandTokens?: string[];
  ocrAddr?: string[];
};

const DISHES = ['tacos','ramen','sushi','birria','pho','ceviche','pizza','pastor','bbq','burger','arepa','empanada','tlayuda'];

export function cluesFromMeta(meta: { title?: string }, cityGuess?: string): Clues {
  const t = (meta.title || '').toLowerCase();
  const phrases = Array.from(new Set(
    t.split(/[|,\-–:•]/).map(s => s.trim()).filter(Boolean)
  )).slice(0, 4);

  const dish = DISHES.find(d => t.includes(d));
  return { phrases, dish, cityGuess };
}

export function makeQueries(c: Clues) {
  const out = new Set<string>();
  const city = (c.cityGuess || '').trim();

  // Base phrases
  if (c.phrases?.[0]) out.add(`${c.phrases[0]} ${city} restaurant`.trim());
  if (c.phrases?.[1]) out.add(`${c.phrases[1]} ${city}`.trim());
  if (c.dish && city) out.add(`${c.dish} ${city}`.trim());
  if (c.dish && c.phrases?.[0]) out.add(`${c.dish} ${c.phrases[0]} ${city}`.trim());

  // Names and locations from hints/vision
  const hintedNames = [
    c.targetName,
    ...(c.extraNameHints || []),
    ...(Array.isArray(c.visionNames) ? c.visionNames.filter(n => (n.confidence ?? 0) >= 0.4).map(n => n.text) : []),
  ].filter(Boolean) as string[];

  const hintedLocs = [
    city,
    ...(c.extraLocHints || []),
    ...(Array.isArray(c.visionLocs) ? c.visionLocs.filter(l => (l.confidence ?? 0) >= 0.4).map(l => l.text) : []),
  ].filter(Boolean) as string[];

  // Combine top hints conservatively
  for (const n of Array.from(new Set(hintedNames)).slice(0, 4)) {
    const nn = n.trim();
    if (!nn) continue;
    if (hintedLocs.length) {
      for (const l of Array.from(new Set(hintedLocs)).slice(0, 3)) {
        const ll = l.trim();
        if (!ll) continue;
        out.add(`${nn} ${ll}`.trim());
      }
    } else {
      out.add(nn);
    }
    if (c.cuisine) out.add(`${nn} ${c.cuisine}`.trim());
  }

  if (city && out.size < 3) out.add(`restaurant ${city}`);

  return Array.from(out).slice(0, 6);
}